import React from 'react';
import KnowledgeBasePage from '@/components/knowledge/KnowledgeBasePage';

interface AIKnowledgeProps {
  initialKnowledgeBaseId?: string;
}

const AIKnowledge = ({ initialKnowledgeBaseId }: AIKnowledgeProps) => {
  return (
    <KnowledgeBasePage
      embeddedInMapleOS
      initialKnowledgeBaseId={initialKnowledgeBaseId}
      appTitle="AI Knowledge"
    />
  );
};

export default AIKnowledge;
